import React, { useRef, useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import SimpleReactValidator from "simple-react-validator";
import { translate } from "../../../../locale";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import AuthServices from "../../../../services/AuthServices";
import PropTypes from "prop-types";

const { Title, Text } = Typography;

const SimpleReactValidatorMessage = (message) => (
  <div className="text-red-600 pt-2 text-xs">{message}</div>
);

const ChangePasswordBox = ({ username, password, isAdmin, extProvider }) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    new_password: "",
  });
  const [, forceUpdate] = useState();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: SimpleReactValidatorMessage,
      messages: {
        required: "Campo requerido",
        password:
          "La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un número",
      },
      validators: {
        password: {
          rule: (val) => {
            const uppercaseRegExp = /[A-Z]/;
            const lowercaseRegExp = /[a-z]/;
            const digitsRegExp = /\d/;
            const hasMinLength = (str) => str.length >= 8;

            return (
              val.length >= 8 &&
              uppercaseRegExp.test(val) === true &&
              lowercaseRegExp.test(val) === true &&
              digitsRegExp.test(val) === true &&
              hasMinLength(val)
            );
          },
          message: "",
        },
      },
    })
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const resetForm = () => {
    setValues({
      new_password: "",
    });
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleChangePassword = async () => {
    setLoading(true);
    try {
      const data = {
        patient: username,
        new_password: values.new_password,
      };

      const response = await AuthServices.changePasswordForUser(data);

      if (response?.data?.error) {
        message.error("Hubo un problema en cambiar la contraseña del usuario");
      } else {
        resetForm();
        message.success("Contraseña cambiada exitosamente");
      }
    } catch (error) {
      message.error("Error al cambiar la contraseña");
      console.error("Error on change password: ", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Form
      autoComplete="off"
      className="w-full"
      form={form}
      initialValues={{
        new_password: password || "",
      }}
    >
      <Text>{translate("Contraseña del usuario")}</Text>
      <div className="flex mb-6">
        <Form.Item className="mb-0 flex-1">
          <Input
            placeholder={translate("Nueva contraseña")}
            type={visible ? "text" : "password"}
            name="new_password"
            onChange={handleChange}
            onBlur={handleChange}
            disabled={!isAdmin || extProvider}
            value={values?.new_password}
            suffix={
              visible ? (
                <EyeInvisibleOutlined onClick={() => setVisible(false)} />
              ) : (
                <EyeOutlined onClick={() => setVisible(true)} />
              )
            }
          />
          {simpleValidator.current.message(
            "new_password",
            values.new_password,
            "required|password"
          )}
        </Form.Item>
      </div>
      <div>
        <Button
          className=" bg-custom_green text-white border-0 hover:bg-custom_green hover:text-white focus:bg-custom_green focus:text-white disabled:bg-gray-300 disabled:text-white"
          onClick={() => {
            handleChangePassword();
          }}
          loading={loading}
          disabled={
            !isAdmin ||
            extProvider ||
            loading ||
            !simpleValidator.current.allValid()
          }
        >
          {translate("Cambiar contraseña")}
        </Button>
      </div>
    </Form>
  );
};

ChangePasswordBox.propTypes = {
  username: PropTypes.string,
  password: PropTypes.string,
  isAdmin: PropTypes.bool,
  extProvider: PropTypes.bool,
};

export default ChangePasswordBox;
